module.exports = __webpack_public_path__ + "static/media/handFlexed2Right.86e3493e.png";